// extracted by mini-css-extract-plugin
module.exports = {"root":"equipments-page_root__F9pTQ","content":"equipments-page_content__pib4k","pagination":"equipments-page_pagination__ZnZFA"};